namespace GeniuzPOS.PosShift {
    export namespace PsTaxInvoiceAddressService {
        export const baseUrl = 'PosShift/PsTaxInvoiceAddress';

        export declare function Create(request: Serenity.SaveRequest<PsTaxInvoiceAddressRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsTaxInvoiceAddressRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsTaxInvoiceAddressRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsTaxInvoiceAddressRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "PosShift/PsTaxInvoiceAddress/Create",
            Update = "PosShift/PsTaxInvoiceAddress/Update",
            Delete = "PosShift/PsTaxInvoiceAddress/Delete",
            Retrieve = "PosShift/PsTaxInvoiceAddress/Retrieve",
            List = "PosShift/PsTaxInvoiceAddress/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsTaxInvoiceAddressService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
